import { Progress } from "antd";
import React from "react";
import { $t } from "~/i18n.js";
import { getLevel, Level } from "./Level.jsx";

export const BADGES_PER_LEVEL = 6;

export const calculateLevel = (earnedCount) => {
  return Math.floor(earnedCount / BADGES_PER_LEVEL) + 1;
};

/**
 * Shows progress between two badge levels with a progress bar.
 *
 *   <Level n>  [====progress bar====>]  <Level n+1>  X te gaan tot volgend niveau
 *
 * Props:
 *   currentLevel  {number}  The level already earned (0 = none yet)
 *   nextLevel     {number}  The next level to unlock
 *   progress      {number}  0.0 – 1.0  how far along toward nextLevel
 */
export const LevelProgress = ({ earnedCount, size = "default" }) => {
  // you always start at level 1
  const currentLevel = calculateLevel(earnedCount);
  const nextLevel = currentLevel + 1;
  const progress = (earnedCount % BADGES_PER_LEVEL) / BADGES_PER_LEVEL;

  const currentLevelData = getLevel(currentLevel);
  const nextLevelData = getLevel(nextLevel);

  const percent = Math.min(100, Math.round(progress * 100));
  const earnedInLevel = Math.round(progress * BADGES_PER_LEVEL);
  const badgesLeft = Math.max(0, BADGES_PER_LEVEL - earnedInLevel);

  const levelSize = size === "small" ? "small" : "default";

  return (
    <div style={{ width: "100%" }}>
      <div
        className="row"
        style={{ alignItems: "center", gap: 8, width: "100%" }}
      >
        <Level level={currentLevel} size={levelSize} />

        <Progress
          percent={percent}
          showInfo={false}
          size="small"
          strokeColor={{
            from: currentLevelData.color,
            to: nextLevelData.color,
          }}
        />

        <Level level={nextLevel} size={levelSize} opacity={0.3} />
      </div>

      <div
        className="row"
        style={{ justifyContent: "space-between", width: "100%" }}
      >
        <span
          style={{
            fontSize: 11,
            color: "#888",
            display: "block",
            textAlign: "left",
            marginTop: 2,
          }}
        >
          {earnedCount} {$t("behaald")}
        </span>

        <span
          style={{
            fontSize: 11,
            color: "#888",
            display: "block",
            textAlign: "right",
            marginTop: 2,
          }}
        >
          {badgesLeft} {$t("te gaan tot volgend niveau")}
        </span>
      </div>
    </div>
  );
};
